/*
 * Filename: grid-config-root.component.tsx
 * Description: component for config tabs.
 */

import React, { Component, ReactNode } from 'react';
import { observer } from 'mobx-react';
import { CQMasterDataStore } from '../../../../store/cq-master-data.store';
import { GridTable } from './grid-table.component';
import { GridTabComponentName } from './grid-tab-component-name';
import { GridTabEditSelected } from './grid-tab-edit-selected.component';
import { GridLevelEditModal } from './header-actions/grid-header-action-modal.component';
import { GridRowActiontModal } from './row-actions/grid-row-action-modal.component';
import { TemplateSFObjectStore } from '../../../../store/models/template-object.model';

class GridConfigComponent extends Component<{ templateName: string, setCustomComponent: Function }, any> {

    constructor(props: Readonly<{ templateName: string, setCustomComponent: Function }>) {
        super(props);
        this.state = {
            isHeaderActionModalVisible: false,
            isRowActionModalVisible: false,
            isApplyRuleModalVisible: false,
            objectName: '',
            appliedRule: '',
            appliedRuleObject: {}
        };
        this.initializeView();
    }

    public initializeView = () => {
        let ruleElementsObj: any = CQMasterDataStore.OutputConfig.getStoreKeyData(this.props.templateName, 'ruleElements');
        if (ruleElementsObj.hasOwnProperty('gridObject') && ruleElementsObj.gridObject.hasOwnProperty('headerActions') && Object.keys(ruleElementsObj.gridObject.headerActions).length > 0) {
            let headerActionTypes: any[] = [];
            Object.keys(ruleElementsObj.gridObject.headerActions).forEach((actionKey: any) => {
                if (ruleElementsObj.gridObject.headerActions[actionKey].actionType !== 'standard_header_action') {
                    headerActionTypes.push(ruleElementsObj.gridObject.headerActions[actionKey]);
                }
            });
            const headerAction: any = TemplateSFObjectStore.objectFields.recordTypeInfos.length > 0 ? [...TemplateSFObjectStore.objectFields.recordTypeInfos] : [];
            let itemIndex;
            const headerActions = headerAction.map((actionType: any, index: number) => {
                let action = { ...actionType };
                if (action.name === 'Master' && headerAction.length > 1) {
                    itemIndex = index;
                } else if (action.name === 'Master' && headerAction.length === 1) {
                    action.name = 'New';
                    action.developerName = 'New';
                }
                return action;
            });
            if (itemIndex) {
                headerActions.splice(itemIndex, 1);
            }
            headerActionTypes = [...headerActionTypes , ...headerActions];
            CQMasterDataStore.GridObject.updateGridField('headerActionTypes', headerActionTypes);
        } else {
            const headerAction: any = TemplateSFObjectStore.objectFields.recordTypeInfos.length > 0 ? [...TemplateSFObjectStore.objectFields.recordTypeInfos] : [];
            let itemIndex;
            const headerActions = headerAction.map((actionType: any, index: number) => {
                let action = { ...actionType };
                if (action.name === 'Master' && headerAction.length > 1) {
                    itemIndex = index
                } else if (action.name === 'Master' && headerAction.length === 1) {
                    action.name = 'New';
                    action.developerName = 'New';
                }
                return action;
            });
            if (itemIndex) {
                headerActions.splice(itemIndex, 1);
            }
            const headerActionsFromStore = CQMasterDataStore.OutputConfig.getHeaderActions(this.props.templateName);

            let storeHeaderAction: any = {};
            let isExistHeaderAction = false;

            let headerActionInConfigFormat: any[] = headerActions.map((defaultheaderAction: any) => {
                const actionName = defaultheaderAction.developerName === 'New' ? `std_new` : `std_new_${defaultheaderAction.developerName.toLowerCase()}`;
                headerActionsFromStore.forEach((headerAction: any) => {
                    if (headerAction.name === actionName) {
                        isExistHeaderAction = true;
                        storeHeaderAction = headerAction;
                    }
                });
                if (isExistHeaderAction) {
                    return storeHeaderAction;
                }
                else {
                    let headerActionRuleElementObj = {
                        isApplyRuleModalVisisble: false,
                        actionType: 'standard_header_action',
                        isRuleApplied: false,
                        visibilityRuleObj: {},
                        visibilityRuleFields: [],
                        isVisible: '',
                        label: defaultheaderAction.name === 'New' ? 'New' : `New ${defaultheaderAction.name}`,
                        parentFields: [],
                        additionalFieldsArray: [],
                        isActionSaved: true,
                        name: actionName
                    };
                    if (ruleElementsObj && ruleElementsObj.gridObject && ruleElementsObj.gridObject.hasOwnProperty('headerActions')) {
                        let ruleElements = { ...ruleElementsObj };
                        let gridObject = { ...ruleElements.gridObject };
                        let headerActions = { ...gridObject.headerActions };
                        headerActions = { ...headerActions, [defaultheaderAction.developerName]: { ...headerActionRuleElementObj } };
                        // gridObj.headerActions[defaultheaderAction.developerName] = { ...headerActionRuleElementObj };
                        gridObject.headerActions = headerActions;
                        ruleElements.gridObject = gridObject;
                        ruleElementsObj = ruleElements;
                    } else {
                        let headerActions: any = {};
                        headerActions = { [defaultheaderAction.developerName]: { ...headerActionRuleElementObj } };
                        // gridObj.headerActions[defaultheaderAction.developerName] = { ...headerActionRuleElementObj };
                        ruleElementsObj.gridObject = { ...ruleElementsObj.gridObject, headerActions };
                        CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(this.props.templateName, 'ruleElements', ruleElementsObj);
                    }
                    CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(this.props.templateName, 'ruleElements', ruleElementsObj);
                    return {
                        name: actionName,
                        label: defaultheaderAction.name === 'New' ? 'New' : `New ${defaultheaderAction.name}`
                    };
                }
            });
            let someIndex;
            headerActionInConfigFormat.forEach((act: any, index: number) => {
                if (act.label === 'New') {
                    someIndex = index;
                }
            });
            if (someIndex) {
                headerActionInConfigFormat.splice(someIndex, 1);
            }
            CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(this.props.templateName, 'headerActions', headerActionInConfigFormat);
            CQMasterDataStore.GridObject.updateGridField('headerActionTypes', headerActions);
        }
        if (ruleElementsObj.gridObject.hasOwnProperty('rowActions') && Object.keys(ruleElementsObj.gridObject.rowActions).length > 0) {
            let rowActionTypes = [];
            Object.keys(ruleElementsObj.gridObject.rowActions).forEach((actionKey: string) => {
                rowActionTypes.push(ruleElementsObj.gridObject.rowActions[actionKey])
            });
            if (!ruleElementsObj.gridObject.rowActions.hasOwnProperty('edit')) {
                rowActionTypes.push({ name: 'edit' });
            }
            if (!ruleElementsObj.gridObject.rowActions.hasOwnProperty('delete')) {
                rowActionTypes.push({ name: 'delete' });
            }
            CQMasterDataStore.GridObject.updateGridField('rowActionTypes', rowActionTypes);
        } else {
            CQMasterDataStore.GridObject.updateGridField('rowActionTypes', [{ name: 'edit' }, { name: 'delete' }]);
        }
    }

    render(): ReactNode {
        const componentLevelConfigTabData = CQMasterDataStore.GridObject.gridComponentConfigView;
        return (
            <div id="tab-default-2" className="slds-tabs_default__content slds-p-around_small scroll-content full-height"
                role="tabpanel" aria-labelledby="tab-default-2__item">
                {
                    componentLevelConfigTabData.hasOwnProperty('displayFields') && componentLevelConfigTabData.displayFields.length > 0 ? <div className="slds-grid slds-grid_vertical full-height">
                        <div className="slds-grid slds-grid_align-spread slds-m-bottom_small">
                            <GridTabComponentName selectedTemplate={this.props.templateName} />
                            <div className="slds-grid slds-grid_vertcial-align-center">
                            <button className="slds-button slds-button_brand" onClick={() => this.componentEventHandler()}>Component Event</button>
                                <div className="slds-button-group" role="group">
                                    <button className="slds-button slds-button_icon slds-button_icon-border-filled"
                                        onClick={() => { this.setState({ isHeaderActionModalVisible: true }) }} >
                                        <i className="cq-icon-change_record_type"></i>
                                    </button>
                                    <GridTabEditSelected toggleModalVisibility={this.toggleHeaderActionModal} headerActionType={CQMasterDataStore.GridObject.headerActionTypes} selectedTemplateName={this.props.templateName} />
                                </div>
                            </div>

                        </div>
                        <GridTable toggleModalVisibility={this.toggleRowActionModal} rowActionType={CQMasterDataStore.GridObject.rowActionTypes} selectedTemplateName={this.props.templateName} />
                    </div> : <div>
                            Please select Fields To Display
                    </div>
                }
                {
                    this.state.isHeaderActionModalVisible && <GridLevelEditModal
                        selectedTemplateName={this.props.templateName}
                        toggleModalVisibility={this.toggleHeaderActionModal}
                        headerActionType={CQMasterDataStore.GridObject.headerActionTypes}
                        updateHeaderActionType={this.updateHeaderActionType}
                    />
                }
                {this.state.isRowActionModalVisible &&
                    <GridRowActiontModal
                        selectedTemplateName={this.props.templateName}
                        toggleModalVisibility={this.toggleRowActionModal}
                        rowActionType={this.state.rowActionType}
                        updateRowActionType={this.updateRowActionType}
                    />
                }
            </div >
        );
    }

    /**
     * @private
     * @memberof GridConfigComponent
     */
    private toggleHeaderActionModal = () => {
        this.setState({
            isHeaderActionModalVisible: !this.state.isHeaderActionModalVisible,
        });
    }

    /**
     * @private
     * @memberof GridConfigComponent
     */
    private toggleRowActionModal = () => {
        this.setState({
            isRowActionModalVisible: !this.state.isRowActionModalVisible,
        });
    }

    public updateHeaderActionType = (headerActionType: any) => {
        CQMasterDataStore.GridObject.updateGridField('headerActionTypes', headerActionType);
    }

    public updateRowActionType = (rowActionType: any) => {
        CQMasterDataStore.GridObject.updateGridField('rowActionTypes', rowActionType);
    }

    /**
     * @private populates selected field details object to trigger component event rule modal
     * @memberof GridConfigComponent
     */
    private componentEventHandler = () => {
        CQMasterDataStore.GridObject.updateGridField('selectedAction', 'gridComponentLayout');
        const layoutEvents = { isComponentEventRule: true, fullName: 'componentLayout', objectName: 'componentLayout', label: 'componentLayout', type: 'component' };
        CQMasterDataStore.Details.setSelectedFieldDetailsObject(layoutEvents);
    }
}

export const GridConfigRootComponent = observer(GridConfigComponent);